import React from 'react';
import { QuantityUnit } from '../types/api';

interface QuantityWithUnitInputProps {
  value: string;
  unit: QuantityUnit;
  onValueChange: (value: string) => void;
  onUnitChange: (unit: QuantityUnit) => void;
  min?: number;
  hasError?: boolean;
  disabled?: boolean;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  dataItemId?: number;
}

const UNITS: { value: QuantityUnit; label: string }[] = [
  { value: 'unidad', label: 'un' },
  { value: 'kg', label: 'kg' },
  { value: 'lt', label: 'lt' },
];

export const QuantityWithUnitInput: React.FC<QuantityWithUnitInputProps> = ({
  value,
  unit,
  onValueChange,
  onUnitChange,
  min = 1,
  hasError = false,
  disabled = false,
  onBlur,
  onKeyDown,
  dataItemId,
}) => {
  const borderClass = hasError
    ? 'border-destructive focus-within:border-destructive'
    : 'border-border focus-within:border-primary';

  return (
    <div
      className={`flex items-stretch w-full rounded-md border-2 bg-background transition-colors overflow-hidden ${borderClass} ${disabled ? 'opacity-50' : ''}`}
    >
      {/* Number — takes all available space */}
      <input
        type="number"
        aria-label="Cantidad"
        min={min}
        value={value}
        disabled={disabled}
        onChange={(e) => {
          const v = e.target.value;
          if (v === '' || /^\d*$/.test(v)) {
            onValueChange(v);
          }
        }}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        className="flex-1 min-w-0 w-0 px-2 py-1.5 font-sans font-medium text-base outline-none bg-transparent text-center [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none disabled:cursor-not-allowed"
        style={{ border: 'none', boxShadow: 'none' }}
        {...(dataItemId !== undefined ? { 'data-qty-item-id': dataItemId } : {})}
      />
      {/* Unit selector — compact suffix */}
      <div className="flex items-center shrink-0 border-l-2 border-border pl-1 pr-0.5">
        <select
          value={unit}
          disabled={disabled}
          onChange={(e) => onUnitChange(e.target.value as QuantityUnit)}
          className="font-sans text-xs text-muted-foreground bg-transparent outline-none cursor-pointer appearance-none disabled:cursor-not-allowed"
          style={{ border: 'none', boxShadow: 'none', width: '18px' }}
        >
          {UNITS.map((u) => (
            <option key={u.value} value={u.value}>
              {u.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default QuantityWithUnitInput;
